<template>
  <div>
    <v-dialog :value="value" @input="$emit('input')" width="1000px" scrollable>
      <v-card>
        <v-toolbar dark flat absolute color="primary" width="100%">
          <v-toolbar-title>{{termsAndConditions.title[selectedLang]}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="disagree">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <!-- <v-toolbar-items>
            <v-btn dark text @click="close"> Save </v-btn>            
          </v-toolbar-items> -->
        </v-toolbar>
        <v-card-title></v-card-title>   
        <v-card-text  style="margin-top:50px;" >
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" align="left">
                <div>
                  <h1>{{termsAndConditions.title[selectedLang]}}</h1>
                  <div v-html="termsAndConditions.html[selectedLang]"></div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>          
          <v-row style="margin-bottom:10px !important;">
            <v-col cols="12" align="right" style="margin-right:20px"> 
              <v-container >
                <v-btn color="success" @click="agree">
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>{{termsAndConditions.confirmButtonText}}</v-btn>               
                <v-btn color="error" @click="disagree" >
                  <v-icon dark left> mdi-cancel</v-icon>{{termsAndConditions.cancelButtonText}}</v-btn>           
              </v-container>
            </v-col>
          </v-row>  
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import rateCardConfig from './config';
export default {
  name: 'Influencer-Terms-Modal',
  props: {
    dialogTitle: String,
    value: Boolean,
    selectedLang: String
  },
  data () {
    return {
      termsAndConditions: rateCardConfig.rateCardTermsAndCondition,
      showContractModal: false,
      agreement: '',
      valid: true,
      alert: false
    }
  },
  methods: {
    agree: function() {
      this.$emit('termsAggrement', true);
      this.$emit('input');
    },
    disagree: function() {
      this.$emit('input');
    },
    getLang() {
      this.$emit('getLang')
    }
  }
};
</script>




// WEBPACK FOOTER //
// RateCardTermsModal.vue?78c95bda